var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 35.25V23.5a17.625 17.625 0 0135.25 0v11.75",
    stroke: "#e95832",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 37.208a3.916 3.916 0 01-3.917 3.917H35.25a3.917 3.917 0 01-3.917-3.917v-5.875a3.917 3.917 0 013.917-3.916h5.875v9.791zm-35.25 0a3.917 3.917 0 003.917 3.917h1.958a3.917 3.917 0 003.917-3.917v-5.875a3.917 3.917 0 00-3.917-3.916H5.875v9.791z",
    stroke: "#e95832",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/head_phone.caa33359.svg";
export { SvgHeadPhone as ReactComponent };